angular
	.module 'App.Repository'
	.factory 'BulkDataRepository',
		[
			'BaseRepository', 'BACKEND_REPORT_TYPE', '$q',
			(BaseRepository, BACKEND_REPORT_TYPE, $q) ->
				class BulkDataRepository extends BaseRepository
					@resource = '/bulk_data'
					@isRestricted = true

					saveWithAttachment: (model, requestBody) ->
						@request('POST', @getUrl('/' + model), requestBody, @getConfigForRequestWithAttachment())

					findByQuery: ->
						supportedTypes = [
							BACKEND_REPORT_TYPE.PRODUCTS,
							BACKEND_REPORT_TYPE.STOCK_VALUES,
							BACKEND_REPORT_TYPE.CUSTOMERS,
							BACKEND_REPORT_TYPE.TICKETS,
							BACKEND_REPORT_TYPE.CUSTOMER_PRICES,
							BACKEND_REPORT_TYPE.TRANSLATIONS,
							BACKEND_REPORT_TYPE.USERS,
							BACKEND_REPORT_TYPE.PURCHASE_ORDERS,
							BACKEND_REPORT_TYPE.SHOPS
						]
						data = supportedTypes.map((type) => {id: type, name: type})

						return $q.when({data: data})

				return new BulkDataRepository
		]
